module.exports = __webpack_public_path__ + "img/MB_Monogram_White_RGB.8617a41b.png";